import { BoMItemFilter } from 'features/BillOfMaterials/BoMItemFilter/Filter/BoMItemFilter'
import _, { forEach } from 'lodash'
import { BoMItemRow, PartTypeRow } from 'model/Project/BoMItemRow'
import {
  WorkingStepDto,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { store } from 'store/configureStore'
import { ProjectState } from 'store/Project/ProjectTypes'

function applyWorkingStepFilter(
  workingSteps: WorkingStepDto[],
  enabledWorkingSteps: WorkingStepType[],
  bypassEmptyEnabledWorkingSteps?: boolean,
  showAll?: boolean,
  strategy: 'showIfAny' | 'showIfAll' = 'showIfAll'
) {
  if (showAll) {
    return true
  }

  if (!enabledWorkingSteps?.length) {
    // if (bypassEmptyEnabledWorkingSteps) return true

    return Boolean(workingSteps?.length) === false
  }

  if (strategy === 'showIfAll') {
    const intersection = _.intersection(
      workingSteps.map((x) => x.primaryWorkingStep),
      enabledWorkingSteps
    )
    return (
      intersection.length === enabledWorkingSteps.length &&
      workingSteps.length === enabledWorkingSteps.length
    )
  }

  return workingSteps
    .map((x) => x.primaryWorkingStep)
    .some((ws) => enabledWorkingSteps.includes(ws))
}

function applyMaterialKeywordFilter(
  bomItemKeywords: string[],
  enabledKeywords: string[],
  showAll: boolean,
  showIfAny?: boolean
) {
  if (showAll) {
    return true
  }

  if (enabledKeywords?.length === 0) {
    return bomItemKeywords.length === 0
  }

  if (!bomItemKeywords.length) {
    return false
  }

  // if (!enabledKeywords?.length || !bomItemKeywords.length) {
  //   return false
  // }

  const intersection = _.intersection(enabledKeywords, bomItemKeywords)

  if (showIfAny && intersection.length > 0) {
    return true
  }

  if (intersection.length === 0) {
    return false
  }

  return (
    intersection.length ===
    Math.min(enabledKeywords.length, bomItemKeywords.length)
  )
  // return _.difference(bomItemKeywords, enabledKeywords).length === 0
  // return bomItemKeywords.some((keyword) => enabledKeywords.includes(keyword))
}

export function BoMItemSatisfyActiveFilters(
  filter: ProjectState['filters'],
  bomItem: BoMItemRow
) {
  if (Object.values(filter).findIndex((x) => x.active === true) === -1) {
    return true
  }

  if (!bomItem) return false

  let show = true

  switch (bomItem?.type) {
    case 'Row': {
      show = BoMItemFilter(filter, bomItem)
      break
    }
    case 'MaterialHeader': {
      const partTypeWorkingSteps = _.flatMap(
        bomItem.partTypeIds,
        (x) =>
          (store.getState().project.flatView[x] as PartTypeRow).workingSteps
      )

      if (filter.byMaterialKeywords.active) {
        const groups = Object.keys(
          filter?.byMaterialKeywords?.filter?.enabledFilters || {}
        )

        forEach(
          groups,
          (group) =>
            (show &&= applyMaterialKeywordFilter(
              Object.values(bomItem.materialSummary.tokens)
                .flat()
                .map((x) => x.originalKeyword),
              Object.values(
                filter.byMaterialKeywords.filter.enabledFilters[group]
              )
                .flat()
                .map((x) => x.originalKeyword),
              filter.byMaterialKeywords.filter.enabledFilters[group].length ===
                filter.byMaterialKeywords.filter.availableFilters[group].length
            ))
        )
      }

      show ||=
        (filter.byWorkingStep.active &&
          applyWorkingStepFilter(
            [...bomItem.workingStepDtos, ...partTypeWorkingSteps],
            filter.byWorkingStep.filter.enabledFilters
          )) ||
        bomItem.filteredPartTypeIds?.length > 0

      break
    }
    case 'AssemblyHeader': {
      show =
        BoMItemFilter(filter, bomItem) ||
        bomItem.filteredPartTypeIds?.length > 0

      break
      // show =
      //   !filter.byWorkingStep.active ||
      //   applyWorkingStepFilter(
      //     bomItem.assembly.assemblyWorkingStepDtos,
      //     filter.byWorkingStep.filter.enabledFilters,
      //     true,
      //     false,
      //     'showIfAny'
      //   ) ||
      //   applyWorkingStepFilter(
      //     bomItem.assembly.partTypeWorkingStepDtos,
      //     filter.byWorkingStep.filter.enabledFilters,
      //     false,
      //     false,
      //     'showIfAny'
      //   )
      // break
    }
    case 'Assembly': {
      show = false //make it invisible by default

      show =
        (filter.byWorkingStep.active &&
          (applyWorkingStepFilter(
            bomItem.workingSteps,
            filter.byWorkingStep.filter.enabledFilters,
            true,
            false,
            'showIfAny'
          ) ||
            applyWorkingStepFilter(
              bomItem.partTypeWorkingStepDtos,
              filter.byWorkingStep.filter.enabledFilters,
              false,
              false,
              'showIfAny'
            ))) ||
        bomItem.filteredPartTypeIds?.length > 0
      break
    }
  }

  return show
}
